import { useMemo } from "react";
import { faRotateLeft, faRotateRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ActionIcon, Group } from "@mantine/core";
import { Tooltip } from "components/UI/Tooltip";
import { CollapsibleWidthComponent } from "components/UI/TopMenu/CollapsibleComponent";
import { useTranslation } from "react-i18next";
import { useRouting } from "stores/routingStore/RoutingContext";

export const UndoRedoButtons = ({ isOpen }: { isOpen: boolean }) => {
  const {
    history: { canUndo, canRedo, undo, redo },
  } = useRouting();
  const { t } = useTranslation();

  return useMemo(
    () => (
      <CollapsibleWidthComponent height={28} width={57} isOpen={isOpen}>
        <Group
          wrap="nowrap"
          gap={1}
          sx={(theme, u) => ({
            [u.dark]: {
              backgroundColor: theme.colors.dark[7],
            },
            borderRadius: theme.radius.sm,
          })}
        >
          <Tooltip label={t("editmode.undo_tooltip")}>
            <div>
              <ActionIcon
                variant="light"
                disabled={!canUndo}
                onClick={undo}
                styles={(theme, _, u) => ({
                  root: {
                    [u.dark]: {
                      color: !canUndo ? undefined : theme.colors.violet[2],
                      backgroundColor: !canUndo
                        ? undefined
                        : theme.colors.dark[6],
                    },
                  },
                })}
                sx={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
              >
                <FontAwesomeIcon icon={faRotateLeft} />
              </ActionIcon>
            </div>
          </Tooltip>
          <Tooltip label={t("editmode.redo_tooltip")}>
            <div>
              <ActionIcon
                variant="light"
                disabled={!canRedo}
                onClick={redo}
                styles={(theme, _, u) => ({
                  root: {
                    [u.dark]: {
                      color: !canRedo ? undefined : theme.colors.violet[2],
                      backgroundColor: !canRedo
                        ? undefined
                        : theme.colors.dark[6],
                    },
                  },
                })}
                sx={{
                  borderTopLeftRadius: 0,
                  borderBottomLeftRadius: 0,
                }}
              >
                <FontAwesomeIcon icon={faRotateRight} />
              </ActionIcon>
            </div>
          </Tooltip>
        </Group>
      </CollapsibleWidthComponent>
    ),
    [canRedo, canUndo, isOpen, redo, t, undo]
  );
};
